<!--
로딩(배경 오버레이), block ui기능 컴포넌트
-------------------
-->
<template>
    <div class="overlay" :class="overlayClass">
        <div class="dialog">
            <slot name="dialog" >
                <loading-icon></loading-icon>
                처리중입니다. 잠시만 기다리세요..
            </slot>
        </div>

    </div>
</template>

<script>
    import LoadingIcon from "./loading-icon.vue";

    export default {
        components: {LoadingIcon},
        props: {
        },
        data: function () {
            return {
                // (bool) on/off 여부
                on: false,
            };
        },
        computed: {
            /**
             * overlay 요소 css 클래스명
             */
            overlayClass() {
                return {
                    on: this.on,
                };
            },
        },
        methods: {
            overlayOn() {
                this.on = true;
            },
            overlayOff() {
                this.on = false;
            },

        },
    }
</script>


<style lang="scss" scoped>

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .dialog {
        //width: 90%;
        //padding: 1rem;
        //background-color: #fff;
        color: #fff;

    }

    &.on {
        display: flex;
    }
}

</style>